import styles from './index.module.scss'
import styles2 from '../index.module.scss'
import { Divider, Table, message, Col, Input } from 'antd'
import { useState, useEffect, useRef, useContext, useMemo } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import PSAIModal from '@PSAIComponents/PSAIModal';
import TabCom from '../hooks/TabCom'
import Iconfont from '@utils/Iconfont';
import InvitationLink from '../hooks/InvitationLink';
import { AppContext } from '@utils/AppContext';
import eventBus from '@utils/eventBus';
import TopWrap from '../hooks/TopWrap';
import API from '@api/api';
import { useNavigate } from 'react-router-dom';



const MemberManage = () => {
    const { globalUser, globalOrgInfo, globalBalance, globalFreeze } = useContext(AppContext);
    const [logLoading, setLogLoading] = useState(false)
    const [memberList, setMemberList] = useState([])
    const [nickName, setNickName] = useState('')
    const [bindingId, setBindingId] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [activeIndex, setActiveIndex] = useState('enterpriseMember')
    const [editNameVisible, setEditNameVisible] = useState(false)
    const editNameModalRef = useRef(null);
    const invitationLinkModalRef = useRef(null);
    const navigate = useNavigate()

    const memberColumns = [{
        title: '成员昵称',
        key: 'orgNickname',
        render: (record) => {
            return record.deleted ? <span style={{ color: '#B9C3D0' }}>{record.orgNickname}（已移除）</span> : record.orgNickname
        }
    }, {
        title: '手机号',
        dataIndex: 'mobile',
        key: 'mobile',
    }, {
        title: '角色',
        dataIndex: 'role',
        key: 'role',
        render: (record) => {
            return record.role == 'admin' ? '超级管理员' : '成员'
        }
    }, {
        title: '状态',
        key: 'status',
        render: (record) => {
            return record.status ? '正常' : <span style={{ color: '#FF3B30' }}>未激活</span>
        }
    }, {
        title: '操作',
        key: 'action',
        width: 300,
        fixed: "right",
        render: (_, record) => {
            return <>
                {
                    !record.deleted && <>
                        <span className={styles.operationSpan}
                            onClick={() => {
                                setNickName(record.orgNickname)
                                setBindingId(record.id)
                                setEditNameVisible(true)
                            }}>修改昵称</span>
                        {
                            (record.role != 'admin' && memberLevel != 0 ) && <>
                                <Divider type="vertical" />
                                <span className={styles.operationSpan}
                                    onClick={() => {
                                        handleRemove(record.id)
                                    }}>移除成员</span>
                            </>
                        }
                        {
                            (!record.status && memberLevel != 0 ) && <>
                                <Divider type="vertical" />
                                <span className={styles.operationSpan}
                                    style={{ color: '#006EFF', cursor: "pointer" }}
                                    onClick={() => eventBus.emit('OPEN_DATA_SEAT')}>增加席位</span>
                            </>
                        }
                    </>
                }
            </>
        }
    }]

    const handleRemove = (bindingId) => {
        PSAIModal.confirm({
            content: <span style={{ color: "#FF3B30" }}>请确认是否移除该成员？</span>,
            onOk() {
                removeMember(bindingId)
            }
        })
    }

    const removeMember = (bindingId) => {
        API.removeMember({
            bindingId: bindingId,
        }).then((res) => {
            if (res.code !== 0) message.error(res.msg)
            message.success('移除成功')
            getListOrgMember()
            eventBus.emit('getUserOrgInfo')
        })
    }

    const titleList = [{
        label: '企业成员',
        key: 'enterpriseMember',
    }]

    const getListOrgMember = () => {
        API.getListOrgMember({}).then((res) => {
            if (res.code !== 0) message.error(res.msg)
            setMemberList(res.data)
        })
    }

    useEffect(() => {
        getListOrgMember()
    }, [])

    useEffect(() => {
        if (globalOrgInfo?.isPersonal) {
            navigate('/home/personalCenter/personalTransaction')
        }
    }, [globalOrgInfo])

    const updateNickName = () => {
        API.updateNickName({
            nickName: nickName,
            bindingId: bindingId,
        }).then((res) => {
            if (res.code !== 0) message.error(res.msg)
            message.success('修改成功')
            setEditNameVisible(false)
            getListOrgMember()
        })
    }

    const remainingMembers = useMemo(() => {
        return globalOrgInfo?.current?.supportMembers - globalOrgInfo?.current?.currentMembers
    }, [globalOrgInfo])


    const memberLevel = useMemo(() => {
        return (globalUser?.membership?.level && globalUser?.membership?.level != -100)  ? 
        globalUser?.membership?.level : 0
    }, [globalUser])

    const handleInvitation = () => {
        if (memberLevel === 0) {
            message.info('购买会员可获得更多席位！')
            eventBus.emit('recharge')
            return
        } else if (remainingMembers === 0) {
            // if (memberLevel === 5) {
            //     message.error('升级会员可获得更多席位！')
            //     eventBus.emit('recharge')
            //     return
            // } else {
                message.error('您的企业已达最大成员数，可购买更多席位！')
                eventBus.emit('OPEN_DATA_SEAT')
                return
            // }
        } else {
            invitationLinkModalRef.current.setInvitationLinkVisible(true)
        }
    }

    return (
        <div className={styles.MemberManage}>
            <TopWrap type="member" />
            <div className={styles2.tableWrap}>
                <TabCom items={titleList} getActiveIndex={setActiveIndex} />
                <span
                    onClick={() => handleInvitation()}
                    className={styles.inviteMember}><PlusOutlined />&nbsp;&nbsp;邀请成员</span>
                <Table
                    className='personalTable'
                    loading={logLoading}
                    rowKey="title"
                    columns={memberColumns}
                    dataSource={memberList}
                    tableLayout="auto"
                    pagination={false}
                    scroll={{
                        x: 'max-content',
                        y: `calc(100vh - 550px)`,
                    }}
                />
            </div>
            <InvitationLink ref={invitationLinkModalRef} />
            <PSAIModal
                title='修改昵称'
                maxWidth={400}
                okText={'确定'}
                open={editNameVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: false }}
                onCancel={() => setEditNameVisible(false)}
                onOk={() => updateNickName()}
            >
                <div className={styles.editNameContent}>
                    <Input
                        value={nickName}
                        prefix={<Iconfont className={styles.Icon} type="icon-reuseOutlined" />}
                        suffix={`${nickName.length}/20`}
                        onChange={(e) => setNickName(e.target.value)}
                        maxLength={20}
                        placeholder='请输入昵称' />
                </div>
            </PSAIModal>
        </div>
    )
}

export default MemberManage